import { useLayoutEffect, useState } from "react";

const MOBILE_WIDTH_THRESHOLD = 768; // Define the threshold for mobile devices

export function useScreenSize() {
  const [screenSize, setScreenSize] = useState({
    // Initial values to avoid hydration issues
    // On client side, these will be updated to actual window size in the useEffect below
    width: 1300,
    height: 1300,
    isMobile: false,
  });

  useLayoutEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobile: window.innerWidth < MOBILE_WIDTH_THRESHOLD,
      });
    };
    handleResize();

    window.addEventListener("resize", handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return screenSize;
}
